import { render, staticRenderFns } from "./sum-poster.vue?vue&type=template&id=76b68129&scoped=true&"
import script from "./sum-poster.vue?vue&type=script&lang=js&"
export * from "./sum-poster.vue?vue&type=script&lang=js&"
import style0 from "./sum-poster.vue?vue&type=style&index=0&id=76b68129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b68129",
  null
  
)

export default component.exports